import { useEffect, useState, useContext } from "react";
import styles from "./styles.module.css";
import { BlocksValue } from "../../../contexts/blocks";
import Render from "../../canvas/paper/render";

export default function Preview({ style }) {
  const blocks = useContext(BlocksValue);
  const [_block, setBlock] = useState(null);

  useEffect(() => {
    const props = {};
    if (style) {
      const schema = blocks.find((x) => x.name === style.component);
      if (!schema) {
        setBlock(null);
        return;
      }
      schema.props.forEach((p) => {
        if (style.props[p.name]) {
          props[p.name] = style.props[p.name];
        } else {
          props[p.name] = p.editorParams.default;
        }
      });
      const _block = {
        component: style.component,
        name: "Preview",
        props,
        dynamic: schema.dynamic ? schema.dynamic : null,
        children: [],
      };
      setBlock(_block);
    }
  }, [style, blocks]);

  if (!_block) {
    return null;
  }
  return (
    <div className={styles.preview}>
      <div className={styles.header}>Preview</div>
      <div className={styles.previewContainer}>
        {_block && <Render block={_block} index={0} />}
        <div
          onClick={(e) => e.stopPropagation()}
          className={styles.previewCover}
        ></div>
      </div>
    </div>
  );
}
